import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VStack, Heading, Text, Spinner } from '@chakra-ui/react';
import GenericCard from '@components/GenericCard';
import { CARD_TYPE } from '@constants';
import { getFulfillmentBalances } from '@store/actions/rdaDashboardActions';

const FulfillmentBalances = () => {
  const dispatch = useDispatch();
  const fulfillmentBalances = useSelector((state) => state?.rdaDashboard?.fulfillmentBalances);

  useEffect(() => {
    dispatch(getFulfillmentBalances());
  }, [dispatch]);

  return (
    <VStack alignItems="stretch" gap={3}>
      <Heading size="md" color="white">RDA Balances</Heading>
      {fulfillmentBalances?.isLoading && <Spinner color="#81ebab" />}
      {fulfillmentBalances?.isError && <Text color="red.400">{fulfillmentBalances.error || 'Failed to load fulfillment balances.'}</Text>}
      {!fulfillmentBalances?.isLoading && !fulfillmentBalances?.isError && fulfillmentBalances?.data && fulfillmentBalances.data.length === 0 && (
        <Text color="gray.400">No RDA balances found.</Text>
      )}
      {!fulfillmentBalances?.isLoading && !fulfillmentBalances?.isError && fulfillmentBalances?.data && fulfillmentBalances.data.length > 0 && (
        <VStack alignItems="stretch" gap={2}>
          {fulfillmentBalances.data.map((item, idx) => (
            <GenericCard
              key={idx}
              cardData={item}
              cardType={CARD_TYPE.FULFILLMENT_BALANCE_CARD}
            />
          ))}
        </VStack>
      )}
    </VStack>
  );
};

export default FulfillmentBalances; 